const WIDGET_SRC = '/steam/widget/widget.js';
const WIDGET_THEME = 'playstea';

const findWidgetScript = () =>
  document.querySelector(`script[src*="${WIDGET_SRC}"]`);

// Запасной вариант: если наш чат не поднялся, подключаем Jivo (если id задан)
function loadJivo(jivoId) {
  if (!jivoId || document.querySelector('script[data-steam-jivo]')) return;
  const jivo = document.createElement('script');
  jivo.src = `https://code.jivosite.com/widget/${encodeURIComponent(jivoId)}`;
  jivo.async = true;
  jivo.setAttribute('data-steam-jivo', '');
  document.head.appendChild(jivo);
}

// Раньше виджет подключался тегом в index.html; теперь — после ответа активации
export function loadSupportChat() {
  if (findWidgetScript()) return;
  const jivoId = process.env.REACT_APP_JIVO_SITE_ID || '';
  const script = document.createElement('script');
  script.src = WIDGET_SRC;
  script.setAttribute('data-theme', WIDGET_THEME);
  script.setAttribute('data-jivo-id', jivoId);
  script.onload = () => {
    if (!document.getElementById('steam-support-chat')) loadJivo(jivoId);
  };
  script.onerror = () => loadJivo(jivoId);
  document.head.appendChild(script);
}

// Загруженный виджет не убрать начисто: если он уже на странице
// (в открытой вкладке вставили чужую ссылку), перезагружаем страницу
export function dropSupportChatOnMismatch(
  reload = () => window.location.reload()
) {
  if (findWidgetScript()) reload();
}
